// Sprint 2.4C (Candidate Data Export / Transaction Experience): client-side "export what's on
// screen" for admin list pages. This is deliberately separate from the existing server-side
// ExportCandidates_new.jsx (EPPlus-based, exports ALL rows matching a filter, not just the current
// page) — no duplication of that reusable full/bulk export path, this only covers the already
// server-paginated `this.state.data` a list page already has loaded.

function csvEscape(value) {
  if (value === null || value === undefined) {
    return '';
  }
  const stringValue = String(value);
  if (/[",\n]/.test(stringValue)) {
    return '"' + stringValue.replace(/"/g, '""') + '"';
  }
  return stringValue;
}

function exportToCsv(filename, columns, rows) {
  const headerRow = columns.map((col) => csvEscape(col.title)).join(',');
  const dataRows = rows.map((row) =>
    columns.map((col) => csvEscape(typeof col.dataIndex === 'function' ? col.dataIndex(row) : row[col.dataIndex])).join(',')
  );
  const csvContent = [headerRow, ...dataRows].join('\r\n');

  const blob = new Blob(['﻿' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export default { exportToCsv };
